






import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import MainForm from "@/views/MainForm.vue";
import { FailuresHeader } from "@dsm/dsm-storybook";
import { headerInformation } from "@/service/initial-data";

const advise = namespace("advise");

@Component({
  components: {
    MainForm,
    FailuresHeader
  }
})
export default class BaseLayout extends Vue {
  headerInformation = headerInformation;
}
